import React from 'react';
import { func, bool } from 'prop-types';
import styles from './IconButton.scss';
import classNames from 'classnames';

export default class IconButton extends React.Component {
  state = { animation: false };

  handleClick = e => {
    this.setState({ animation: false });
    this.animationTimeout = setTimeout(() => {
      this.setState({ animation: true });
    }, 0);
    this.props.onClick(e);
  };

  componentWillUnmount() {
    clearTimeout(this.animationTimeout);
  }

  render() {
    const { animation } = this.state;
    const { children, disabled, small } = this.props;
    return (
      <button
        onClick={this.handleClick}
        disabled={disabled}
        className={classNames([styles.button, small && styles.small, animation && styles.animationClass])}
      >
        {children}
      </button>
    );
  }
}

IconButton.displayName = 'IconButton';
IconButton.propTypes = {
  onClick: func,
  disabled: bool,
  small: bool,
};
